<template>
  <el-select
    :value="inputValue"
    reserve-keyword
    :placeholder="placeholder"
    :loading="selectStatus"
    @change="transValue"
    :disabled="selectStatus"
  >
    <el-option
      v-for="item in states"
      :key="item + Date.parse(new Date())"
      :label="item"
      :value="item"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "searchSelect",
  model: {
    prop: "inputValue",
    event: "change"
  },
  props: {
    placeholder: String,
    url: String,
    inputValue: String,
    selectStatus: {
      type: Boolean,
      default: true
    },
    states: Array,
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      value: [],
      list: [],
      loading: false
    };
  },
  methods: {
    transValue(v) {
      v;
      this.$emit("change", v);
    }
  }
};
</script>

<style lang="less" scoped>
.el-select {
  border-radius: 0px !important;
  margin-bottom: 20px;
  width: 100%;
}
</style>
<style lang="less">
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1;
  }
}
</style>
